// extracted by mini-css-extract-plugin
module.exports = {"SPlayerContainer":"TrailerPlayer_SPlayerContainer__GcsIu","SYTIframe":"TrailerPlayer_SYTIframe__Bvh3i"};